function initializeAddEvents() {
    if ($('.addeventatc').length > 0) {
        $.cachedScript('https://addevent.com/libs/atc/1.6.1/atc.min.js').done(function(script) {
            addeventatc.settings({
                license: 'aZSXKzeRPzKWStQuRmNt12487',
                css: false
            });
        });
    }
}

function setSelectedCurrency(currency) {
    $.post('/currency/set', {
            "": currency
        })
        .done(function() {
            window.location.reload(true);
        });
}

function initializeBasicDropdown() {
    $('.basic-dropdown').multiselect({
        buttonContainer: '<div class="btn-group btn-block"></div>',
        buttonClass: 'btn btn-default btn-lg btn-block',
        templates: {
            button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown" tabindex="2" accesskey="t"><span class="multiselect-selected-text"></span> <b class="caret"></b></button>',
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block"></ul>'
        },
        onChange: function(element, checked) {
            loadSearchType();
        },
    });
}

function analyticsListingCallback(listingId, url) {
    $.ajax({
        headers: {
            "X-XSRF-Token": $("input[name='__RequestVerificationToken']").val()
        },
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        url: url,
        data: JSON.stringify(listingId)
    });
}

function analyticsListingImageView(listingId) {
    analyticsListingCallback(listingId, '/analytics/listing-image-view');
}

function analyticsShareEmail(listingId) {
    analyticsListingCallback(listingId, '/analytics/share-email');
}

function analyticsPrint(listingId) {
    analyticsListingCallback(listingId, '/analytics/print');
}

function analyticsShareFacebook(listingId) {
    analyticsListingCallback(listingId, '/analytics/share-facebook');
}

// function preventWebViewInputScroll() {
//     var saveScrollLeft;
//     $("input, textarea")
//         .focus(function() {
//             clearTimeout(blurTimeoutId);
//             saveScrollLeft = $("body").scrollLeft();
//         })
//         .blur(function() {
//             blurTimeoutId = setTimeout(function() {
//                 $(window).scrollLeft(saveScrollLeft);
//             }, 1000);
// });
// }

function calculateFromNow() {
    $('.from-now').each(function() {
        var now = moment();
        var eventTime = moment($(this).data('time'));
        var tomorrow = now.add(1, 'day');
        var oneHour = eventTime.add(1, 'hour');
        var calculate = eventTime.fromNow();
        if (eventTime.isSame(tomorrow, 'day')) {
            $(this).html('tomorrow!');
        } else if (now.isBetween(eventTime, oneHour)) {
            $(this).html('now!');
        } else if (now.isAfter(oneHour)) {
            $(this).html('');
        } else {
            $(this).html(calculate);
        }
    });
}

function stopPropagationMegaMenu() {
    $(document).on('click', '.megamenu .dropdown-menu', function(e) {
        e.stopPropagation();
    });
}

function initializePLYR() {
    var playerControl = document.querySelector('.default-player');
    if (playerControl) {
        var player = new Plyr(document.querySelector('.default-player'), {
            iconURl: '/wwwapplication/img/svg/symbol-defs.svg'
        });
    }
}

function initializeAnalytics() {
    $('#share, #print').click(function() {
        var listingId = $(this).parents('[data-listingid]').data('listingid');
        analyticsListingImageView(listingId);
    });
}

function extendMatchHeightBootstrap() {
    $('.collapse').on('shown.bs.collapse', function() {
        $.fn.matchHeight._update(false);
    });
    $('.modal').on('shown.bs.modal', function(e) {
        $.fn.matchHeight._update(false);
    });
    $('.modal').on('hidden.bs.modal', function(e) {
        $.fn.matchHeight._update(false);
    });
    $('.dropdown').on('shown.bs.dropdown', function(e) {
        $.fn.matchHeight._update(false);
    });
    $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
        $.fn.matchHeight._update(false);
    });
}

function displayListingCard(elements) {
    var elems = $(elements),
        count = elems.length;
    elems.each(function() {
        var $this = $(this);
        var getListingId = $this.data('id');
        $.ajax({
            url: '/Search/GetSearchResultListing/' + getListingId,
            fail: function(result) {
                $this.remove();
            },
            success: function(result) {
                $this.html(result);
                slickResultsWhenVisible();
            },
            complete: function() {
                $(window).lazyLoadXT();
            }
        });
    });
}

function internationalPhoneInput() {
    $('.intl-phone').intlTelInput({
        initialCountry: 'auto',
        preferredCountries: ['nz','au','gb','fj','cn'],
        geoIpLookup: function(callback) {
            $.get('http://ipinfo.io', function() {}, 'jsonp').always(function(resp) {
                var countryCode = (resp && resp.country) ? resp.country : '';
                callback(countryCode);
            });
        },
        utilsScript: '/public/js/phoneutils.min.js',
        customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
          return "e.g. " + selectedCountryPlaceholder;
        }
    });
}


function initializeBayleysAutocomplete() {
    $('#top-nav-search-input').autocomplete({
        serviceUrl: '/search-api/everything-search',
        dataType: 'json',
        transformResult: function (response) {
            return {
                suggestions: $.map(response, function (dataItem) {
                    return {
                        value: dataItem.Text,
                        data: {
                            category: dataItem.Category,
                            id: dataItem.Id
                        }
                    };
                })
            };
        },
        triggerSelectOnValidInput: false,
        minChars: 3,
        maxHeight: 'auto',
        forceFixPosition: true,
        appendTo: '#topNavigationSearch',
        groupBy: 'category',
        zIndex: 1040,
        onSelect: function (suggestion) {
            var autocompleteredirect = true;
            if ($(this).attr('data-autocompleteredirect') &&
                $(this).attr('data-autocompleteredirect').length > 0) {
                if (!$(this).data('autocompleteredirect'))
                    autocompleteredirect = false;
            }
            if (autocompleteredirect) {
                if (suggestion.data.category === 'Agents') {
                    $('form#keywordsSearchFormNav')
                        .attr('action', '/Franchises/ShortAgentUrl/' + suggestion.data.id)
                        .submit();
                } else if (suggestion.data.category === 'Offices') {
                    $('form#keywordsSearchFormNav')
                        .attr('action', '/Franchises/ShortUrl/' + suggestion.data.id)
                        .submit();
                }
            }
        }
    });

    $('#footer-nav-search-input').autocomplete({
        serviceUrl: '/search-api/everything-search',
        dataType: 'json',
        transformResult: function (response) {
            return {
                suggestions: $.map(response, function (dataItem) {
                    return {
                        value: dataItem.Text,
                        data: {
                            category: dataItem.Category,
                            id: dataItem.Id
                        }
                    };
                })
            };
        },
        triggerSelectOnValidInput: false,
        minChars: 3,
        maxHeight: '300',
        groupBy: 'category',
        onSelect: function (suggestion) {
            var autocompleteredirect = true;
            if ($(this).attr('data-autocompleteredirect') &&
                $(this).attr('data-autocompleteredirect').length > 0) {
                if (!$(this).data('autocompleteredirect'))
                    autocompleteredirect = false;
            }
            if (autocompleteredirect) {
                if (suggestion.data.category === 'Agents') {
                    $('form#keywordsSearchFormFooter')
                        .attr('action', '/Franchises/ShortAgentUrl/' + suggestion.data.id)
                        .submit();
                } else if (suggestion.data.category === 'Offices') {
                    $('form#keywordsSearchFormFooter')
                        .attr('action', '/Franchises/ShortUrl/' + suggestion.data.id)
                        .submit();
                }
            }
        }
    });
}

function initializeGlobalElements() {
    stopPropagationMegaMenu();
    initializePLYR();
    initializeAnalytics();
    calculateFromNow();
    extendMatchHeightBootstrap();
    initializeAddEvents();
    internationalPhoneInput();
    displayListingCard('.listing-widget');
    $('#userProfileUpdateModal').modal({
        show: true,
        backdrop: 'static',
        keyboard: false
    });
    initializeBayleysAutocomplete(); //Agent and Office autocomplete for input fields
}

function getHeight() {
    if (window.innerHeight > (980 + 40)) return 980;
    return window.innerHeight - 110;
}

function getModalWidth() {
    if (window.innerWidth >= 1280) return 1280;
    if (window.innerWidth >= 992) return 990;

    var percent = (window.innerWidth / 100)
    return (percent * 95);
}

$('#vegaModal').on('hidden.bs.modal', function () {
    $(this).find('iframe').html("").attr("src", "");
});

$('button.vega-button.mortgage-calc').on('click', function (e) {
    var src = $(this).attr('data-src');
    var title = $(this).attr('data-title');
    var height = $(this).attr('data-height') || getHeight();
    //var width = $(this).attr('data-width') || getWidth();

    $('#vegaModal .modal-content .modal-body').height(height);// .width(getModalWidth());

    $("#vegaModal .vega-title").html(title);

    $("#vegaModal iframe").attr({
        'src': src,
        'height': height,
        // 'width': width
    });
});

$('.vega-button').hover(function () {
    $(this).find('.svg-vega').toggle();
}, function () {
    $(this).find('.svg-vega').toggle();
});

$('.vega a').hover(function () {
    $(this).find('.svg-vega').toggle();
}, function () {
    $(this).find('.svg-vega').toggle();
});